import { Draft, PayloadAction } from '@reduxjs/toolkit';
import { IInvoiceState }        from 'Redux/Slices/Invoice/InvoiceSlice';
import { removeActionTypes }    from 'Utils/ReducerUtility';

export const downloadTicketsFromInvoiceRequest = (state: Draft<IInvoiceState>, { type }: PayloadAction<{ id: string }>) => {
  state.openRequests = [ ...state.openRequests, type ];
  state.failedRequests = removeActionTypes(state.failedRequests, type);
  state.updatedAt = Date.now();
};

export const downloadTicketsFromInvoiceSuccess = (state: Draft<IInvoiceState>, { type }: PayloadAction) => {
  state.updatedAt = Date.now();
  state.openRequests = removeActionTypes(state.openRequests, type);
};

export const downloadTicketsFromInvoiceFailure = (state: Draft<IInvoiceState>, { type }: PayloadAction<{ error: any }>) => {
  state.updatedAt = Date.now();
  state.failedRequests = [ ...state.failedRequests, type ];
  state.openRequests = removeActionTypes(state.openRequests, type);
};
